
import merkle from 'merkle-tree-gen';


export default function generateTreePro(inputs, originals) {
    return new Promise(function pro(resolve, reject) {
        const args = {
                array: inputs,
                hashalgo: 'sha256', //TODO: make customizeable
                hashlist: true, //TODO: change this for customizeable leaf hashes
            };
        merkle.fromArray(args, function done(err, tree) {
            if( err ) {
                reject(err);
            }
            else {
                const root = {name: tree.root, hash: tree.root},
                    formatted = formatTree(root, tree, originals);
                resolve([formatted]);
            }
        });
    });
}


function formatTree(root, reference, originals) {
    const vertex = reference[root.hash];
    if( vertex.type === 'leaf' || (vertex.type === 'root' && vertex.left === 'data' && vertex.right === 'data') ) {
        // doing an old-fashioned "filter" instead of "find",
        // because the "collections" node module polluted the Array prototype
        const found = originals.filter(x => x.hash === root.hash),
            data = found.length ? found[0].data : 'input',
            name = data.length > 7 ? (data.slice(0, 7) + '...') : data;
        root.children = [{ name }];
        return root;
    }
    ['left', 'right'].forEach(function checkChildren(side) {
        if( vertex[side] && vertex[side] !== 'data' ) {
            if( !root.children ) {
                root.children = [];
            }
            const child = {
                    hash: vertex[side],
                    name: vertex[side].slice(0,5) + '...',
                };
            root.children.push(formatTree(child, reference, originals));
        }
    })
    return root;
}




// WEBPACK FOOTER //
// ./src/reducers/merkle-tree.js